import { render, staticRenderFns } from "./ConnectedCarFooter.vue?vue&type=template&id=78a5c522&scoped=true&"
import script from "./ConnectedCarFooter.vue?vue&type=script&lang=js&"
export * from "./ConnectedCarFooter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a5c522",
  null
  
)

export default component.exports